import React from 'react';
import AddressLinkMaybe from './AddressLinkMaybe';
import config from '../../config';

import css from './TransactionPanel.module.css';
import classNames from 'classnames';

// Functional component as a helper to build detail card headings
const DetailCardHeadingsMaybe = props => {
  const {
    showDetailCardHeadings,
    listingTitle,
    subTitle,
    location,
    geolocation,
    showAddress,
    transaction,
    isCustomer,
    isMobile
  } = props;

  const providerInfo = transaction?.provider?.attributes?.profile?.publicData;
  const customerInfo = transaction?.customer?.attributes?.profile?.publicData;
  const listingInfo = transaction?.listing?.attributes?.publicData;

  const catOptions = config.custom.filters.find(item => item.id === "category")?.config?.options;
  const sizeOptions = config.custom.filters.find(item => item.id === "companySize")?.config?.options;

  const selectedLabel = (selectedOptions, options) => {

    if(Array.isArray(selectedOptions) ) {
      const selectedArr = options?.filter(o1 => selectedOptions.find(o2 => o2 === o1.key));
      const selectedLabels = selectedArr?.map(item => item.label);

      return selectedLabels?.join(", ");
    } else {
      return options.filter(item => item.key === selectedOptions)?.[0]?.label
    }
  }
  
  return showDetailCardHeadings ? (
    <div className={classNames(css.detailCardHeadings, { [css.detailCardHeadingsMobile]: isMobile })}>
      <h2 className={css.detailCardTitle}>{isCustomer ? listingTitle : customerInfo?.companyName}</h2>
      
      {isCustomer && (
        <>
          <div className={css.infoItem}>
            {!!providerInfo?.website &&
              <span>
                <b>Website: </b>
                <a href={providerInfo.website} target='_blank'>{providerInfo.website}</a>
              </span>}
          </div>
          <div className={css.infoItem}>
            {!!providerInfo?.address && (
              <span>
                <b>Location:</b>
                {providerInfo.address}
              </span>
            )}
          </div>
          <div className={css.infoItem}>
            {!!listingInfo?.category && (
              <span>
                <b>Business type:</b>
                {selectedLabel(listingInfo?.category, catOptions)}
              </span>
            )}
          </div>
          <div className={css.infoItem}>
            {!!listingInfo?.companySize?.[0] && (
              <span>
                <b>Company size:</b>
                {selectedLabel(listingInfo?.companySize?.[0], sizeOptions)}
              </span>)}
          </div>
        </>
      )}
    </div>
  ) : null;
};

export default DetailCardHeadingsMaybe;
